var map = {
	"./Android.png": "2473",
	"./about1.png": "0204",
	"./about2.png": "3892",
	"./about3.png": "a4e0",
	"./about4.png": "fe29",
	"./amint_1.png": "4513",
	"./amint_2.png": "4edd",
	"./amint_3.png": "1d7f",
	"./amint_4.png": "e71c",
	"./app.png": "dd76",
	"./banner.png": "d22d",
	"./banner2.png": "d99f",
	"./banner3.png": "6d94",
	"./banner5.png": "92a1",
	"./cargo_app.png": "3c48",
	"./cargo_bz.png": "1f0e",
	"./cargo_qr.png": "f999",
	"./cartype1.png": "1059",
	"./cartype2.png": "28e0",
	"./chat.png": "84f6",
	"./contact_icon1.png": "0c41",
	"./contact_icon2.png": "05db",
	"./contact_icon3.png": "516d",
	"./contact_icon4.png": "cec4",
	"./driver_app.png": "162c",
	"./driver_bz.png": "698e",
	"./driver_qr.png": "0dac",
	"./email.png": "8608",
	"./head.png": "4c45",
	"./head2.png": "0544",
	"./home_1.png": "109b",
	"./home_2.png": "ce41",
	"./home_3.png": "3cbe",
	"./home_4.png": "9856",
	"./ios.png": "c127",
	"./kefu.png": "7eb4",
	"./ywfw.png": "41e0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";